import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

const params = new URLSearchParams(window.location.search);
let termsUri = '/main/rewards';
let mobile = false;
if (params.get('mobile')) {
  mobile = true;
  termsUri = '/main/rewards?mobile=true';
}

const TermsAndConditionsView = () => {
  const [destinationName, setDestinationName] = useState('');
  const [appName, setAppName] = useState('');
  const [programName, setProgramName] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const appInfo = await StorageHandler.load(storageKeys.appInfo);
      if (appInfo) {
        setDestinationName(appInfo.destinationName);
        setAppName(appInfo.appName);
        setProgramName(appInfo.clientName);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="contentContainer BookingForm TermsAndConditions">
      <div className="header">
        <h3>{i18n.translate('rewards.termsConditions.title')}</h3>
      </div>
      <div className="bodyRewardsTerms">
        <p className="text--bold">
          {i18n.translate('rewards.termsConditions.sectionHeaders.eligibility')}
        </p>
        <p>
          {i18n.translate(
            'rewards.termsConditions.textContent.eligibilityDescription',
            { appName }
          )}
        </p>
        <ul>
          <li>
            {i18n.translate(
              'rewards.termsConditions.textContent.eligibilityRule'
            )}
          </li>
        </ul>
        <p className="text--bold">
          {i18n.translate('rewards.termsConditions.sectionHeaders.conditions')}
        </p>
        <p>
          {i18n.translate(
            'rewards.termsConditions.textContent.qualifyingDescription'
          )}
        </p>
        <ul>
          {Array.from({ length: 8 }, (_, i) => (
            <li key={i}>
              {i18n.translate(
                `rewards.termsConditions.textContent.entrys.${i + 1}`,
                {
                  span: (
                    <span className="text--bold">
                      {i18n.translate(
                        `rewards.termsConditions.textContent.entrys.span.${
                          i + 1
                        }`
                      )}
                    </span>
                  ),
                }
              )}
            </li>
          ))}
        </ul>

        <p className="text--bold">
          {i18n.translate(
            'rewards.termsConditions.sectionHeaders.fiscalResponsibility'
          )}
        </p>
        <ul>
          {Array.from({ length: 7 }, (_, i) => (
            <li key={i}>
              {i18n.translate(
                `rewards.termsConditions.textContent.fiscalResponsibilityRules.${
                  i + 1
                }`,
                { clientName: programName, destinationName }
              )}
            </li>
          ))}
        </ul>

        <br />
        <hr />

        <div className="buttonHolder">
          <Link to={termsUri}>
            <button className="btn" type="button">
              {i18n.translate('rewards.termsConditions.button')} &gt;
            </button>
          </Link>
        </div>
      </div>

      {mobile && (
        <style>
          {
            '\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
          }
        </style>
      )}
    </div>
  );
};

export default TermsAndConditionsView;
